import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Shell from "./components/Shell";

import Dashboard from "./pages/Dashboard";
import Showroom from "./pages/Showroom";
import CarDetail from "./pages/CarDetail";
import Leads from "./pages/Leads";
import Service from "./pages/Service";
import Intake from "./pages/Intake";
import IntakeDetail from "./pages/IntakeDetail";
import JobCards from "./pages/JobCards";
import JobCardDetail from "./pages/JobCardDetail";
import WIP from "./pages/WIP";
import TestDrives from "./pages/TestDrives";
import Stores from "./pages/Stores";
import Accounting from "./pages/Accounting";
import Customers from "./pages/Customers";
import Vendors from "./pages/Vendors";
import Employees from "./pages/Employees";
import Reports from "./pages/Reports";
import Warranty from "./pages/Warranty";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import VerifyWarranty from "./pages/VerifyWarranty";
import Portal from "./pages/portal/Portal";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--kk-bg)]">
        <div className="font-display text-2xl animate-pulse">KARR KRAFT</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ className: "font-sans" }} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/warranty/verify/:token" element={<VerifyWarranty />} />
            <Route path="/portal/*" element={<Portal />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/showroom" element={<Protected><Showroom /></Protected>} />
            <Route path="/showroom/:id" element={<Protected><CarDetail /></Protected>} />
            <Route path="/leads" element={<Protected><Leads /></Protected>} />
            <Route path="/service" element={<Protected><Service /></Protected>}>
              <Route index element={<Navigate to="intake" replace />} />
              <Route path="intake" element={<Intake />} />
              <Route path="jobcards" element={<JobCards />} />
              <Route path="wip" element={<WIP />} />
              <Route path="testdrives" element={<TestDrives />} />
            </Route>
            <Route path="/service/intake/:id" element={<Protected><Service /></Protected>}>
              <Route index element={<IntakeDetail />} />
            </Route>
            <Route path="/service/jobcards/:id" element={<Protected><Service /></Protected>}>
              <Route index element={<JobCardDetail />} />
            </Route>
            <Route path="/stores" element={<Protected><Stores /></Protected>} />
            <Route path="/accounting" element={<Protected><Accounting /></Protected>} />
            <Route path="/customers" element={<Protected><Customers /></Protected>} />
            <Route path="/vendors" element={<Protected><Vendors /></Protected>} />
            <Route path="/employees" element={<Protected><Employees /></Protected>} />
            <Route path="/warranty" element={<Protected><Warranty /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/users" element={<Protected><Users /></Protected>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
